import { createBrowserRouter, RouterProvider, Outlet } from 'react-router';
import { routes } from './routes';
import { MiniAppBootstrap } from './MiniAppBootstrap';

const router = createBrowserRouter([
  {
    element: <MiniAppBootstrap><Outlet /></MiniAppBootstrap>,
    children: routes,
  },
]);

export function AppRouter() {
  return <RouterProvider router={router} />;
}
